import { useSalesTypes } from '@/hooks/features/salesType'

export const useCheckSalesTypesMaster = () => {
  const { isLoading, isSuccess } = useSalesTypes({
    config: {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    },
  })

  return {
    isStored: isSuccess,
    isLoading,
  }
}
